module.exports = __webpack_public_path__ + "static/Pt01-80872ab2f4d791a220128d710c6767be.jpg";